import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from  '../common/widget/valueBox'
import Row from  '../common/layout/row'
import InfoBox from  '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ReactExport from 'react-export-excel-fixed-xlsx';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import imagemUser from '../assets/images/user.jpg';
import {
	setFiltro, getListaDespesa, getListaContaPagar, getListaReceita, getListaContaReceber
} from './dashboardActions';
import { getLista as getListaEmpresa } from '../empresa/empresaActions';
import { getLista as getListaCentroCusto } from '../centroCusto/centroCustoActions';
import { getLista as getListaFornecedor } from '../fornecedor/fornecedorActions';
import { getLista as getListaAnalitica } from '../analitica/analiticaActions';
import { getLista as getListaFormaPagamento } from '../formaPagamento/formaPagamentoActions';
import { getLista as getListaDestinatario } from '../destinatario/destinatarioActions';

import contentCardBody from '../common/template/contentCardBody';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class Dashboard extends Component {

	state = {
		pesquisar: ''
	}

	constructor(props) {
		super(props);
    }

    componentDidMount() {
		this.props.getListaDespesa();
		this.props.getListaContaPagar();
		this.props.getListaReceita();
		this.props.getListaContaReceber();
		this.props.getListaEmpresa();
		this.props.getListaCentroCusto();
		this.props.getListaFornecedor();
		this.props.getListaAnalitica();
		this.props.getListaFormaPagamento();
		this.props.getListaDestinatario();
    }

    render() {

		let totalDespesasPagas = 0;
		let qtdDespesasPagas = 0;
		this.props.listaDespesasPagas.map(item => {
			totalDespesasPagas += parseFloat(item.valor);
			qtdDespesasPagas += parseInt(item.qtd_itens || 0);
		});

		let totalReceitasRecebidas = 0;
		let qtdReceitasRecebidas = 0;
		this.props.listaReceitaRecebida.map(item => {
			totalReceitasRecebidas += parseFloat(item.valor);
			qtdReceitasRecebidas += parseInt(item.qtd_itens || 0);
		});

		let totalContasPagar = 0;
		let qtdContasPagar = 0;
		this.props.listaContaPagar.map(item => {
			totalContasPagar += parseFloat(item.valor);
			qtdContasPagar += parseInt(item.qtd_itens || 0);
		});

		let totalContaReceber = 0;
		let qtdContaReceber = 0;
		this.props.listaContaReceber.map(item => {
			totalContaReceber += parseFloat(item.valor);
			qtdContaReceber += parseInt(item.qtd_itens || 0);
		});

        return (
			<Content>
				<ContentCard>
					<ContentCardHeader>
						<Row>						
							<LabelAndInputDate
								maxWidth={180}
								label='Período Inicial'
								cols='12 6 4 4'
								value={this.props.filtro.data_inicial}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										data_inicial: value
									});
								}} />
							
							<LabelAndInputDate
								maxWidth={180}
								label='Período Final'
								cols='12 6 4 4'
								value={this.props.filtro.data_final}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										data_final: value
									});
								}} />

							<Select
								maxWidth={400}
								options={this.props.listaEmpresa}
								label='Empresa'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_empresa: values.map(item => item.value)
									});
								}} />
							
							<Select
								maxWidth={400}
								options={this.props.listaCentroCusto}
								label='Centro de Custo'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_centro_custo: values.map(item => item.value)
									});
								}} />
								
							<Select
								maxWidth={400}
								options={this.props.listaFornecedor}
								label='Fornecedor'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_fornecedor: values.map(item => item.value)
									});
								}} />
							
							<Select
								maxWidth={400}
								options={this.props.listaAnalitica}
								label='Analítica'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_analitica: values.map(item => item.value)
									});
								}} />
							
							<Select
								maxWidth={400}
								options={this.props.listaFormaPagamento}
								label='Forma de Pagamento'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_forma_pagamento: values.map(item => item.value)
									});
								}} />
							
							<Select
								maxWidth={400}
								options={this.props.listaDestinatario}
								label='Origem / Destino'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_destinatario: values.map(item => item.value)
									});
								}} />
							
							<a class='btn btn-app bg-primary'
								style={{ marginTop: 8 }}
								onClick={() => {
									this.props.getListaDespesa();
									this.props.getListaContaPagar();
									this.props.getListaReceita();
									this.props.getListaContaReceber();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
						</Row>
					</ContentCardHeader>
					<ContentCardBody>

						<div 
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'center',
								flexWrap: 'wrap'
							}}>
							<div 
								style={{
									width: 250,
									border: '2px solid #c72424',
									padding: 10,
									borderRadius: 8,
									margin: 8
								}}>
								<h6 style={{ fontWeight: 'bold', textAlign: 'center' }}>Pagas</h6>
								<h4 style={{ color: '#c72424', textAlign: 'center' }}>{FormatUtils.formatarValorTela(totalDespesasPagas, 2)}</h4>
								<p style={{ padding: 0, margin: 0, textAlign: 'center' }}>{qtdDespesasPagas == 0 ? 'Nenhuma despesa' : (
									qtdDespesasPagas == 1 ? '1 despesa'
									: `${qtdDespesasPagas} despesas`
								)}</p>
							</div>
							<div 
								style={{
									width: 250,
									border: '2px solid #0b8200',
									padding: 10,
									borderRadius: 8,
									margin: 8
								}}>
								<h6 style={{ fontWeight: 'bold', textAlign: 'center' }}>Recebidas</h6>
								<h4 style={{ color: '#0b8200', textAlign: 'center' }}>{FormatUtils.formatarValorTela(totalReceitasRecebidas, 2)}</h4>
								<p style={{ padding: 0, margin: 0, textAlign: 'center' }}>{qtdReceitasRecebidas == 0 ? 'Nenhuma receita' : (
									qtdReceitasRecebidas == 1 ? '1 receita'
									: `${qtdReceitasRecebidas} receitas`
								)}</p>
							</div>
							<div 
								style={{
									width: 250,
									border: '2px solid #cc5c00',
									padding: 10,
									borderRadius: 8,
									margin: 8
								}}>
								<h6 style={{ fontWeight: 'bold', textAlign: 'center' }}>Contas a Pagar</h6>
								<h4 style={{ color: '#cc5c00', textAlign: 'center' }}>{FormatUtils.formatarValorTela(totalContasPagar, 2)}</h4>
								<p style={{ padding: 0, margin: 0, textAlign: 'center' }}>{qtdContasPagar == 0 ? 'Nenhuma despesa' : (
									qtdContasPagar == 1 ? '1 despesa'
									: `${qtdContasPagar} despesas`
								)}</p>
							</div>
							<div 
								style={{
									width: 250,
									border: '2px solid #365bc2',
									padding: 10,
									borderRadius: 8,
									margin: 8
								}}>
								<h6 style={{ fontWeight: 'bold', textAlign: 'center' }}>Contas a Receber</h6>
								<h4 style={{ color: '#365bc2', textAlign: 'center' }}>{FormatUtils.formatarValorTela(totalContaReceber, 2)}</h4>
								<p style={{ padding: 0, margin: 0, textAlign: 'center' }}>{qtdContaReceber == 0 ? 'Nenhuma receita' : (
									qtdContaReceber == 1 ? '1 receita'
									: `${qtdContaReceber} receitas`
								)}</p>
							</div>
						</div>

						<Table responsive>
							<THead>
								<Tr>
									<Th backgroundColor={'#c72424'} color={'#ffffff'} alignLeft>Contas A Pagar</Th>
									<Th backgroundColor={'#c72424'} color={'#ffffff'} width={100} alignRight>(-) R$</Th>
									<Th backgroundColor={'#c72424'} color={'#ffffff'} width={200} alignRight>{FormatUtils.formatarValorTela(totalDespesasPagas, 2)}</Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.listaDespesasPagas.map((item, i) => {
									return (
										<Tr key={item.id} >
											<Td backgroundColor={i % 2 == 0 ? '#fcc2c2' : '#fae6e6'} alignLeft>{item.nome_analitica}</Td>
											<Td backgroundColor={i % 2 == 0 ? '#fcc2c2' : '#fae6e6'} width={100} alignRight>(-) R$</Td>
											<Td backgroundColor={i % 2 == 0 ? '#fcc2c2' : '#fae6e6'} width={200} alignRight>{FormatUtils.formatarValorTela(item.valor, 2)}</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>
						<Table responsive>
							<THead>
								<Tr>
									<Th backgroundColor={'#0b8200'} color={'#ffffff'} alignLeft>Receitas (recebidas)</Th>
									<Th backgroundColor={'#0b8200'} color={'#ffffff'} width={100} alignRight>(+) R$</Th>
									<Th backgroundColor={'#0b8200'} color={'#ffffff'} width={200} alignRight>{FormatUtils.formatarValorTela(totalReceitasRecebidas, 2)}</Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.listaReceitaRecebida.map((item, i) => {
									return (
										<Tr key={item.id} >
											<Td backgroundColor={i % 2 == 0 ? '#c1d9bd' : '#e7ede6'} alignLeft>{item.nome_analitica}</Td>
											<Td backgroundColor={i % 2 == 0 ? '#c1d9bd' : '#e7ede6'} width={100} alignRight>(+) R$</Td>
											<Td backgroundColor={i % 2 == 0 ? '#c1d9bd' : '#e7ede6'} width={200} alignRight>{FormatUtils.formatarValorTela(item.valor, 2)}</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>

						<Table responsive>
							<THead>
								<Tr>
									<Th backgroundColor={'#cc5c00'} color={'#ffffff'} alignLeft>Contas a Pagar</Th>
									<Th backgroundColor={'#cc5c00'} color={'#ffffff'} width={100} alignRight>(-) R$</Th>
									<Th backgroundColor={'#cc5c00'} color={'#ffffff'} width={200} alignRight>{FormatUtils.formatarValorTela(totalContasPagar, 2)}</Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.listaContaPagar.map((item, i) => {
									return (
										<Tr key={item.id} >
											<Td backgroundColor={i % 2 == 0 ? '#dec9af' : '#f5f2ed'} alignLeft>{item.nome_analitica}</Td>
											<Td backgroundColor={i % 2 == 0 ? '#dec9af' : '#f5f2ed'} width={100} alignRight>(-) R$</Td>
											<Td backgroundColor={i % 2 == 0 ? '#dec9af' : '#f5f2ed'} width={200} alignRight>{FormatUtils.formatarValorTela(item.valor, 2)}</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>
						<Table responsive>
							<THead>
								<Tr>
									<Th backgroundColor={'#365bc2'} color={'#ffffff'} alignLeft>Contas a Receber</Th>
									<Th backgroundColor={'#365bc2'} color={'#ffffff'} width={100} alignRight>(+) R$</Th>
									<Th backgroundColor={'#365bc2'} color={'#ffffff'} width={200} alignRight>{FormatUtils.formatarValorTela(totalContaReceber, 2)}</Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.listaContaReceber.map((item, i) => {
									return (
										<Tr key={item.id} >
											<Td backgroundColor={i % 2 == 0 ? '#cbd6f2' : '#edf0f7'} alignLeft>{item.nome_analitica}</Td>
											<Td backgroundColor={i % 2 == 0 ? '#cbd6f2' : '#edf0f7'} width={100} alignRight>(+) R$</Td>
											<Td backgroundColor={i % 2 == 0 ? '#cbd6f2' : '#edf0f7'} width={200} alignRight>{FormatUtils.formatarValorTela(item.valor, 2)}</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>
					</ContentCardBody>
				</ContentCard>
			</Content>
        )
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.dashboard.aguardando,
	filtro: state.dashboard.filtro,
	listaDespesasPagas: state.dashboard.listaDespesasPagas,
	listaContaPagar: state.dashboard.listaContaPagar,
	listaReceitaRecebida: state.dashboard.listaReceitaRecebida,
	listaContaReceber: state.dashboard.listaContaReceber,
	listaEmpresa: state.empresa.listaSelect,
	listaCentroCusto: state.centroCusto.listaSelect,
	listaFornecedor: state.fornecedor.listaSelect,
	listaAnalitica: state.analitica.listaSelect,
	listaFormaPagamento: state.formaPagamento.listaSelect,
	listaDestinatario: state.destinatario.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setFiltro, getListaDespesa, getListaContaPagar, getListaReceita, getListaContaReceber,
	getListaEmpresa, getListaCentroCusto, getListaFornecedor, getListaAnalitica, getListaFormaPagamento, getListaDestinatario
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
